import { Dropdown, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

import Logo from "assets/images/svg/dexef_logo_nav.svg";
import Language from "assets/images/svg/language.svg";
import { useTranslation } from "react-i18next";
import { useLocalize } from "hooks";
import NotificationIcon from "assets/images/svg/notification_nav.svg";
import More from "assets/images/svg/more.svg";

import { useAuthContext } from "store/auth";
import { client } from "helpers/client";
import { useQuery } from "react-query";
import ServerImage from "components/server-image/server-image";
import CanLoadGuard from "components/private-route/can-load.guard";
import NotificationBox from "components/notifications/notifications-box";

const CustomerNavbar = () => {
  const { t, i18n } = useTranslation();
  const { languages } = useLocalize();
  const [, dispatch] = useAuthContext();
  const { data: customerData } = useQuery("customer-data", () =>
    client("/customer/getCurrentCustomer").then((c) => {
      if (c.error) return Promise.reject();
      return c.response;
    })
  );

  return (
    <Navbar className="customerNavbar" expand="lg" fixed="top">
      <div className="container-fluid">
        <Link className="logo" to="/">
          <img src={Logo} alt="Dexef Logo" />
        </Link>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink className="nav-link" to="/">
              {t("home:navbar.home")}
            </NavLink>
            <CanLoadGuard>
              <NavLink className="nav-link" to="/browse-apps">
                {t("home:navbar.browseApps")}
              </NavLink>
            </CanLoadGuard>
            <NavLink className="nav-link" to="/download-center">
              {t("home:navbar.downloadCenter")}
            </NavLink>
            <NavLink className="nav-link" to="/contact-us">
              {t("home:navbar.contactUs")}
            </NavLink>
          </Nav>

          <Nav className="mr-auto">
            <NavDropdown title={<img src={Language} alt="IconProfile" />} id="basic-nav-dropdown" className="language">
              {languages.map((lang) => (
                <NavDropdown.Item key={lang.code} role={lang.code} onClick={() => i18n.changeLanguage(lang.code)}>
                  {lang.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown>

            <NotificationBox/>
            {/* <NavDropdown
              title={<img src={NotificationIcon} alt="IconProfile" />}
              id="basic-nav-dropdown"
              className="NotificationIcon"
            >
              <div className='notification-header'>
                <h1>NOTIFICATIONS</h1>
                <NavDropdown
                  title={<img src={More} alt="IconProfile" />}
                  id="basic-nav-dropdown"
                  className="more"
                >
                  <NavDropdown.Item> </NavDropdown.Item>

                </NavDropdown>
              </div>
              <div className='notification-Tabs'>
                <div>
                  <Link className='tab active' to="/">read</Link>
                  <Link className='tab' to="/">Unread</Link>
                </div>
              </div>
          
              

            </NavDropdown> */}
            <Dropdown className="profile">
              <Dropdown.Toggle id="dropdown-basic">
                <ServerImage src={customerData?.logo?.fullPath ?? ""} alt="customer-image" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div className="info">
                  <div className="name">
                    <ServerImage src={customerData?.logo?.fullPath ?? ""} alt="customer-image" />
                  </div>
                  <div>
                    <h1>{customerData?.name}</h1>
                    <p>{customerData?.email}</p>
                  </div>
                </div>

                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/my-products">
                    {t("home:navbar.myProducts")}
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/invoices">
                    {t("home:navbar.invoices")}
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/wishlist">
                    {t("home:navbar.wishlist")}
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/account">
                    {t("home:navbar.account")}
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/security">
                    {t("home:navbar.securityLogin")}
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item as='p'>
                  <Link className="nav-link" to="/tickets">
                    {t("home:navbar.tickets")}
                  </Link>
                </Dropdown.Item>

                <Dropdown.Divider />
                <Dropdown.Item onClick={() => dispatch({ type: "logout" })}> {t("home:logout")}</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default CustomerNavbar;
